// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"PersonaPruebaTable_spinnerContainer__Q5KLY","botonAdd":"PersonaPruebaTable_botonAdd__WE8EH"};